"use client";
import { CopyIcon } from "@/assets/icons";
import React, {  useState } from "react";

export default function Clipboard({text}) {
  const [copied, setCopied] = useState(false)


  const clickHandler = async () => {

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch (error) {
    } finally {
      setTimeout(() => setCopied(false), 1500); // Reset copied state after 1.5 seconds
    }
  };

  return (
    <div className="relative">
      <button
        onClick={clickHandler}
        className="  bg-transparent dark:text-dark-neutral-default text-neutral-default transition-all hover:opacity-75 active:scale-90  flex gap-2 py-[10px] px-4 items-center text-sm font-semibold -tracking-[0.28px] "
      >
        <CopyIcon />
        Copy to clipboard
      </button>
      {copied && (
        <div className=" rounded left-0 m-auto right-0 w-fit top-[40px] absolute py-2 px-4 dark:bg-dark-surface3 dark:text-dark-medium bg-surface3 text-medium text-xs animate-fade-in">
          Copied!
        </div>
      )}
    </div>
  );
}
